import React from 'react';

import styles from './style.module.scss';

export default ({ imageDescription, imagePath, text }) => (
  <article className={styles.introStep}>
    <img
      className={styles.introStepImage}
      src={imagePath}
      alt={imageDescription}
    />
    <p>{text}</p>
  </article>
);
